import axiosInstance from "./axiosInstance";

const checkUserEmail = async (email: string) => {
  try {
    const {data} = await axiosInstance.post("/checkUserEmail", {email});
    return data;
  } catch (error: any) {
    if (error.response?.data?.message) {
      throw new Error(error.response.data.message);
    }
    throw new Error("Failed to check email. Please try again.");
  }
};

export default checkUserEmail;
